import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const FieldNotificationsPage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldNotificationsPage })),
);
const FieldSettingsPage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldSettingsPage })),
);
const FieldProfilePage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldProfilePage })),
);
const ExeHomePage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeHomePage })),
);
const ExeApprovalsPage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeApprovalsPage })),
);
const ExeApprovalDetailPage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeApprovalDetailPage })),
);
const ExeAlertsPage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeAlertsPage })),
);
const ExeReportsPage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeReportsPage })),
);
const ExeMePage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeMePage })),
);
const ExeRefPage = lazy(() =>
  import("@/modules/exe").then((m) => ({ default: m.ExeRefPage })),
);
const MobileQualityPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.MobileQualityPage })),
);
const MobileQualityDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.MobileQualityDetailPage })),
);

export const exeRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[PermissionCodes.ExeKpiRead, PermissionCodes.ExeAlertList, PermissionCodes.ExeReportList]}
                match="any"
              />
            ),
            children: [
              {
                index: true,
                element: (
                  <LazyPage>
                    <ExeHomePage />
                  </LazyPage>
                ),
              },
              {
                path: "alerts",
                element: (
                  <LazyPage>
                    <ExeAlertsPage />
                  </LazyPage>
                ),
              },
              {
                path: "reports",
                element: (
                  <LazyPage>
                    <ExeReportsPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms",
                element: (
                  <LazyPage>
                    <MobileQualityPage shell="exe" />
                  </LazyPage>
                ),
              },
              {
                path: "qms/:type/:lotCode",
                element: (
                  <LazyPage>
                    <MobileQualityDetailPage shell="exe" />
                  </LazyPage>
                ),
              },
              {
                path: "ref/:kind",
                element: (
                  <LazyPage>
                    <ExeRefPage />
                  </LazyPage>
                ),
              },
              {
                path: "ref/:kind/:id",
                element: (
                  <LazyPage>
                    <ExeRefPage />
                  </LazyPage>
                ),
              },
            ],
          },
          {
            element: (
              <RequirePermissions
                codes={[PermissionCodes.ExeApprovalList, PermissionCodes.ExeApprovalAct]}
                match="any"
              />
            ),
            children: [
              {
                path: "approvals",
                element: (
                  <LazyPage>
                    <ExeApprovalsPage />
                  </LazyPage>
                ),
              },
              {
                path: "approvals/:id",
                element: (
                  <LazyPage>
                    <ExeApprovalDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
          {
            path: "me",
            element: (
              <LazyPage>
                <ExeMePage />
              </LazyPage>
            ),
          },
          {
            path: "profile",
            element: (
              <LazyPage>
                <FieldProfilePage />
              </LazyPage>
            ),
          },
          {
            path: "settings",
            element: (
              <LazyPage>
                <FieldSettingsPage />
              </LazyPage>
            ),
          },
          {
            path: "notifications",
            element: (
              <LazyPage>
                <FieldNotificationsPage />
              </LazyPage>
            ),
          },
];

